module.exports = __webpack_public_path__ + "img/ep2-7.3e7f9997.jpg";